import "./TheFoundation.module.css";
import Header from "@/reusable_sections/Header";
import TheKeystoneStandard from "./sections/TheKeystoneStandard";
import OurStrategicLeaders from "./sections/OurStrategicLeaders";
import WhyChooseAbj from "./sections/WhyChooseAbj";
import Footer from "@/reusable_sections/Footer";
export default function TheFoundationPage() {
  return <div>
      <Header />
      <TheKeystoneStandard />
      <OurStrategicLeaders />
      <WhyChooseAbj />
      <Footer />
    </div>;
}